import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

interface AccordionSectionProps {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
    className?: string;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({
    title,
    children,
    defaultOpen = false,
    className = ''
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`bg-card border border-border rounded-lg ${className}`}>
            <button
                onClick={toggleAccordion}
                className="w-full px-4 py-3 text-left flex items-center justify-between hover:bg-accent/50 transition-colors rounded-t-lg"
            >
                <h3 className="text-lg font-semibold text-foreground">{title}</h3>
                <FontAwesomeIcon
                    icon={isOpen ? faChevronUp : faChevronDown}
                    className="text-muted-foreground transition-transform duration-200"
                />
            </button>

            {isOpen && (
                <div className="px-4 pb-4 border-t border-border">
                    {children}
                </div>
            )}
        </div>
    );
}; 